export const deadp_legislation = [
  {
    id: 1,
    name: 'constitution of republic of RSA',
    summary: 'shortsummary/constitution of republic of RSA.html',
    link: 'constitution of republic of RSA.pdf',
    audio_en: 'audio/en/constitution of republic of RSA_en.mp3',
    audio_af: 'audio/af/constitution of republic of RSA_af.mp3',
    audio_xh: 'audio/xh/constitution of republic of RSA_xh.mp3'
  }
];